var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { padding: "30px 40px 50px 40px" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Valores Obtenidos" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("DatePicker", {
                                attrs: {
                                  label: _vm.formFields.fecha.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.fecha.id
                                  ),
                                  id: _vm.formFields.fecha.id,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.fecha.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.fecha, "value", $$v)
                                  },
                                  expression: "formFields.fecha.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "time",
                                  "prepend-icon": "access_time",
                                  label: _vm.formFields.hora.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.hora.id
                                  ),
                                  "data-vv-name": _vm.formFields.hora.id,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.hora.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.hora, "value", $$v)
                                  },
                                  expression: "formFields.hora.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "FormFieldsContainer",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.muestraAlertaGenerica,
                              expression: "muestraAlertaGenerica"
                            }
                          ]
                        },
                        _vm._l(_vm.lstCampos, function(campo) {
                          return _c(
                            "v-flex",
                            {
                              key: campo.id,
                              attrs: { xs12: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                ref: campo.id,
                                refInFor: true,
                                attrs: {
                                  label: campo.descripcionCampo,
                                  "error-messages": _vm.errors.collect(
                                    "" + campo.id
                                  ),
                                  "data-vv-name": campo.id,
                                  disabled: true
                                },
                                model: {
                                  value: campo.valor,
                                  callback: function($$v) {
                                    _vm.$set(campo, "valor", $$v)
                                  },
                                  expression: "campo.valor"
                                }
                              })
                            ],
                            1
                          )
                        }),
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.muestraAlertaZona ||
                                _vm.muestraAlertaRuta ||
                                _vm.muestraAlertaVelocidad,
                              expression:
                                "\n              muestraAlertaZona || muestraAlertaRuta || muestraAlertaVelocidad\n            "
                            }
                          ]
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("DatePicker", {
                                attrs: {
                                  label:
                                    _vm.formFields.fechaActividadFinal.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.fechaActividadFinal.id
                                  ),
                                  id: _vm.formFields.fechaActividadFinal.id,
                                  disabled: true
                                },
                                model: {
                                  value:
                                    _vm.formFields.fechaActividadFinal.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaActividadFinal,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.fechaActividadFinal.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "prepend-icon": "access_time",
                                  label:
                                    _vm.formFields.horaActividadFinal.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.horaActividadFinal.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.horaActividadFinal.id,
                                  disabled: true
                                },
                                model: {
                                  value:
                                    _vm.formFields.horaActividadFinal.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.horaActividadFinal,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.horaActividadFinal.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.velocidad.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.velocidad.id
                                  ),
                                  "data-vv-name": _vm.formFields.velocidad.id,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.velocidad.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.velocidad,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.velocidad.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.ubicacion.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.ubicacion.id
                                  ),
                                  "data-vv-name": _vm.formFields.ubicacion.id,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.ubicacion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.ubicacion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.ubicacion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.heading.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.heading.id
                                  ),
                                  "data-vv-name": _vm.formFields.heading.id,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.heading.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.heading,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.heading.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.peakVelocidad.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.peakVelocidad.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.peakVelocidad.id,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.peakVelocidad.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.peakVelocidad,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.peakVelocidad.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.conductor.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.conductor.id
                                  ),
                                  "data-vv-name": _vm.formFields.conductor.id,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.conductor.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.conductor,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.conductor.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.flota.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.flota.id
                                  ),
                                  "data-vv-name": _vm.formFields.flota.id,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.flota.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.flota, "value", $$v)
                                  },
                                  expression: "formFields.flota.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.minutos.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.minutos.id
                                  ),
                                  "data-vv-name": _vm.formFields.minutos.id,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.minutos.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.minutos,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.minutos.value"
                                }
                              })
                            ],
                            1
                          ),
                          !_vm.muestraAlertaVelocidad
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", sm3: "", md3: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.formFields.zona.label,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.zona.id
                                      ),
                                      "data-vv-name": _vm.formFields.zona.id,
                                      disabled: true
                                    },
                                    model: {
                                      value: _vm.formFields.zona.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.zona,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.zona.value"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label:
                                    _vm.formFields.kilometrosAcumulados.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.kilometrosAcumulados.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.kilometrosAcumulados.id,
                                  disabled: true
                                },
                                model: {
                                  value:
                                    _vm.formFields.kilometrosAcumulados.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.kilometrosAcumulados,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.kilometrosAcumulados.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label:
                                    _vm.formFields.horometroAcumulado.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.horometroAcumulado.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.horometroAcumulado.id,
                                  disabled: true
                                },
                                model: {
                                  value:
                                    _vm.formFields.horometroAcumulado.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.horometroAcumulado,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.horometroAcumulado.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.muestraAlertaUsoNoAutorizado,
                              expression: "muestraAlertaUsoNoAutorizado"
                            }
                          ]
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.tolerancia.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tolerancia.id
                                  ),
                                  "data-vv-name": _vm.formFields.tolerancia.id,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.tolerancia.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tolerancia,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.tolerancia.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.muestraAlertaDetencionNoAutorizada,
                              expression: "muestraAlertaDetencionNoAutorizada"
                            }
                          ]
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "numeric",
                                    expression: "'numeric'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.velocidadIgnicion.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.velocidadIgnicion.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.velocidadIgnicion.id,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.velocidadIgnicion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.velocidadIgnicion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.velocidadIgnicion.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }